import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.08] bg-coal" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
          <div>
            <img src="/apx-logo-dark.png" alt="APX Project Solutions" className="h-12 w-auto" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400">
              ASNT Level III–led NDE auditing, inspection, and quality support for the facilities and projects that cannot afford uncertainty.
            </p>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">Navigate</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {[["/", "Home"], ["/services", "Services"], ["/industries", "Industries"], ["/about", "About"], ["/contact", "Contact"]].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="text-zinc-400 transition-colors hover:text-apx">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">Capabilities</h4>
            <ul className="mt-5 space-y-3 text-sm text-zinc-400">
              <li>NDE Auditing — Level III</li>
              <li>VT / MT / PT / UT / PAUT</li>
              <li>Radiographic Film Auditing</li>
              <li>QA/QC &amp; Compliance</li>
              <li>Field &amp; Project Support</li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">Direct Line</h4>
            <a
              href="mailto:APX@apxproject.com"
              data-testid="footer-email-link"
              className="mt-5 inline-flex items-center gap-2 font-display text-xl font-bold uppercase tracking-wide text-white transition-colors hover:text-apx"
            >
              APX@apxproject.com <ArrowUpRight className="h-4 w-4 text-apx" />
            </a>
            <p className="mt-4 text-sm leading-relaxed text-zinc-500">
              Field deployment across the United States.<br />Industrial, pipeline, utility, energy &amp; turnaround operations.
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-white/[0.08] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">© 2026 APX Project Solutions LLC. All rights reserved.</p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600">Precision you can prove.</p>
        </div>
      </div>
    </footer>
  );
}
